import React, { useContext } from 'react';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import { Store } from './Provider';

const Buttons = () => {
  const { dispatch } = useContext(Store);
  const handleResetForm = () => {
    dispatch({ type: 'RESET' });
  };
  return (
    <>
      <Button
        startIcon={<AddIcon />}
        variant="contained"
        color="secondary"
        size="small"
        onClick={handleResetForm}
      >
        جدید
      </Button>
    </>
  );
};

export default React.memo(Buttons);
